import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import PauseIcon from '@ps-design-system/icons/PauseMedia/PauseMedia24';
import PlayIcon from '@ps-design-system/icons/PlayMedia/PlayMedia24';

import { formatVideoTime } from '../../utils/utils';

export const VideoAttachment = ({ asset_url, onClick }) => {
  const [currentSecond, setCurrentSecond] = useState(0);
  const [totalSeconds, setTotalSeconds] = useState(0);
  const [playing, setPlaying] = useState(false);
  const video = useRef(null);

  const playHandler = () => {
    setPlaying(true);
  };

  const pauseHandler = () => {
    setPlaying(false);
  };

  const pause = () => {
    if (video && video.current && !video.current.paused) {
      video.current.pause();
    }
  };

  const play = () => {
    if (video && video.current && video.current.paused) {
      video.current.play();
    }
  };

  const handleTimeUpdate = () => {
    setCurrentSecond(video.current?.currentTime || 0);
  };

  const handleLoad = () => {
    setTotalSeconds(video.current.duration);
  };

  return (
    <div className="Attachment VideoAttachment">
      <video
        muted
        id={asset_url}
        ref={video}
        src={asset_url}
        onPlay={playHandler}
        onPause={pauseHandler}
        onTimeUpdate={handleTimeUpdate}
        onCanPlay={handleLoad}
        onClick={onClick}
        playsInline
        autoPlay={false}
        controls={false}
      />
      <div className="absolute flex middle controls">
        <button
          className="margin-sm-right start-stop-button flex"
          type="button"
          onClick={playing ? pause : play}
        >
          {playing
            ? <PauseIcon />
            : <PlayIcon />
          }
        </button>
        <div className="ellipsis text-xs text-white heavier">{formatVideoTime(currentSecond)} / {formatVideoTime(totalSeconds)}</div>
      </div>
    </div>
  );
};

VideoAttachment.propTypes = {
  asset_url: PropTypes.string,
  onClick: PropTypes.func
};
